// SNES-style palette swap system
// Index mapping: 1=skin, 2=hair, 3=shirt, 4=pants, 5=shoes, 6=outline, 7=highlight, 8=desk, 9=screen
export interface ColorPalette {
  skin: string;
  hair: string;
  shirt: string;
  pants: string;
  shoes: string;
  outline: string;
  highlight: string;
}

export const PALETTES: Record<string, ColorPalette> = {
  blue: {
    skin: '#FFDBB5', hair: '#4A3728', shirt: '#2563EB',
    pants: '#1E3A5F', shoes: '#4A3728', outline: '#1A1A2E', highlight: '#93C5FD',
  },
  green: {
    skin: '#FFDBB5', hair: '#8B4513', shirt: '#16A34A',
    pants: '#1E3A5F', shoes: '#4A3728', outline: '#1A1A2E', highlight: '#86EFAC',
  },
  red: {
    skin: '#F5D0A9', hair: '#2C1810', shirt: '#DC2626',
    pants: '#374151', shoes: '#2C1810', outline: '#1A1A2E', highlight: '#FCA5A5',
  },
  gold: {
    skin: '#FFDBB5', hair: '#1A1A2E', shirt: '#D97706',
    pants: '#44403C', shoes: '#1A1A2E', outline: '#1A1A2E', highlight: '#FDE68A',
  },
  purple: {
    skin: '#F5D0A9', hair: '#6B2C91', shirt: '#7C3AED',
    pants: '#1E293B', shoes: '#3B0764', outline: '#1A1A2E', highlight: '#C4B5FD',
  },
  orange: {
    skin: '#FFDBB5', hair: '#78350F', shirt: '#EA580C',
    pants: '#1E3A5F', shoes: '#78350F', outline: '#1A1A2E', highlight: '#FDBA74',
  },
  cyan: {
    skin: '#F5D0A9', hair: '#164E63', shirt: '#0891B2',
    pants: '#1E293B', shoes: '#164E63', outline: '#1A1A2E', highlight: '#67E8F9',
  },
  pink: {
    skin: '#FFDBB5', hair: '#831843', shirt: '#DB2777',
    pants: '#374151', shoes: '#831843', outline: '#1A1A2E', highlight: '#F9A8D4',
  },
  teal: {
    skin: '#F5D0A9', hair: '#134E4A', shirt: '#0D9488',
    pants: '#1E293B', shoes: '#134E4A', outline: '#1A1A2E', highlight: '#5EEAD4',
  },
  brown: {
    skin: '#FFDBB5', hair: '#451A03', shirt: '#92400E',
    pants: '#1E3A5F', shoes: '#451A03', outline: '#1A1A2E', highlight: '#D6A06C',
  },
  gray: {
    skin: '#F5D0A9', hair: '#374151', shirt: '#6B7280',
    pants: '#1F2937', shoes: '#374151', outline: '#1A1A2E', highlight: '#D1D5DB',
  },
  lime: {
    skin: '#FFDBB5', hair: '#365314', shirt: '#65A30D',
    pants: '#1E293B', shoes: '#365314', outline: '#1A1A2E', highlight: '#BEF264',
  },
  // Manager palette (suit & tie)
  manager: {
    skin: '#FFDBB5', hair: '#1F2937', shirt: '#1E293B',
    pants: '#111827', shoes: '#0F172A', outline: '#1A1A2E', highlight: '#CBD5E1',
  },
};
